export default __webpack_public_path__ + "static/media/slide6.e53330e4.jpg";